import { Component, OnInit } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material';
import { ModalRestorePasswordComponent } from '../../components/modals/restore-password/restore-password.component';

@Component({
    selector: 'app-restore-password',
    templateUrl: './restore-password.component.html',
    styleUrls: ['./restore-password.component.scss']
})
export class RestorePasswordComponent implements OnInit {

    constructor(
        private dialog: MatDialog,
    ) {

    }

    ngOnInit() {
        setTimeout(() => {
            let restoreModal = this.dialog.open(ModalRestorePasswordComponent, {
                height: 'auto',
                minHeight: '63vh',
                disableClose: true
            })
            restoreModal.afterClosed().subscribe(data => {
                if (data) {
                    console.log(data)
                }
            })
        }, 1)
    }

}



// WEBPACK FOOTER //
// ./src/app/pages/restore-password/restore-password.component.ts